export class SortSqlQueryExecutionBy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "SqlQueryExecutionSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortSqlQueryExecutionBy.attributeTypeMap;
    }
    constructor() {
    }
}
